import {
  Component,
  ComponentRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { SideDialogService } from './common/services';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { DialogComponent } from './common/components/center-dialog/dialog.component';
import { Subscription } from 'rxjs';
import { PrimeNGConfig } from 'primeng/api';
import { SharedService } from './common/services/shared.service';
import { SupportChatService } from './core/services/support-chat.service';
import { environment } from '../environments/environment';
import { GlameraSharedService } from './core/services/glamera-shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('sideDialog', {
    static: true,
    read: ViewContainerRef,
  })
  public sideDialog!: ViewContainerRef;

  @ViewChild('userDropdown', { static: false }) userDropdown!: NgbDropdown; // Reference to the user dropdown component for programmatic control
  public glameraURL = environment.saasURL;
  public isMobileMenuOpen = false; // Controls the visibility state of the mobile hamburger menu



  public isShowenSideDialog: boolean = false;
  private sideDialogComponent!: ComponentRef<any>;
  @ViewChild(DialogComponent) dialogComponent!: DialogComponent;

  private subscriptions: Subscription[] = [];

  public constructor(
    public translateService: TranslateService,
    public shared: GlameraSharedService,
    public sharedService: SharedService,
    private router: Router,
    private renderer: Renderer2,
    private sideDialogService: SideDialogService,
    private cookieService: CookieService,
    private primengConfig: PrimeNGConfig,
    private supportChatService: SupportChatService,
  ) {

  }

  ngOnInit(): void {
    this.supportChatService.chatScript();
    this.primengConfig.ripple = true;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public changeLanguage(lang: string): void {
    this.translateService.use(lang);
  }





  logOut(): void {
    this.cookieService.delete('tokenObject', '/', `.${environment.RootDomain}`);
    localStorage.clear();
    window.location.href = environment.saasURL + '/logout';
    return;
  }

  /**
   * Navigates the user to the main Glamera application URL
   * This method is called when the user clicks on "Go to your account" option
   * It redirects to the external Glamera URL using window.location.href
   */
  navigateToGlamera(): void {
    window.location.href = this.glameraURL;
  }

  /**
   * Toggles the application language between English and Arabic
   * This method switches the current language and closes any open dropdown menus
   * It determines the new language based on the current language state
   */
  toggleLanguage(): void {
    const currentLang = this.translateService.currentLang;
    const newLang = currentLang === 'en' ? 'ar' : 'en';
    this.changeLanguage(newLang);
    // Close the dropdown menu after changing language
    if (this.userDropdown) {
      this.userDropdown.close();
    }
  }

  /**
   * Toggles the mobile hamburger menu visibility state
   * This method is called when the user clicks the hamburger menu button
   * It switches between showing and hiding the mobile menu overlay
   */
  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  /**
   * Closes the mobile hamburger menu
   * This method is called when the user clicks outside the menu or on menu items
   * It sets the mobile menu visibility state to false, hiding the overlay
   */
  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  /**
   * Opens WhatsApp support chat in a new tab
   * This method is called when the user clicks on the WhatsApp support button
   * It opens the WhatsApp chat with the support number in a new browser tab
   */
  goToWhatsappSupport(): void {
    window.open('https://wa.me/966551301446', '_blank');
  }
}
